import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { TimebandService } from 'src/app/angularJS/services/timebands/timeband.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

export class TimebandsController {
  public static $inject = [
    'ACTToolbarService',
    'breadcrumbService',
    'timebandService',
    'PrimaryAction',
    '$state',
    'UserMessages',
    'timebandsResponse'
  ];
  public timebands: Array<InterACT.Interfaces.Timebands.Timeband> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };

  constructor(
    private toolbarService: ACTToolbarService,
    private breadcrumbService: BreadcrumbService,
    private timebandService: TimebandService,
    private PrimaryAction: any,
    private $state: ng.ui.IStateService,
    private userMessagesService: UserMessagesService,
    getTimebandsResponse: InterACT.Interfaces.Timebands.TimebandsResponse) {
    this.activate(getTimebandsResponse);
  }

  /**
   * A method that is called to retrieve a page of data
   * @param page the page number to retrieve
   * @param perPage the number of records to retrieve per page
   */
  public getData(page: number, perPage: number) {
    if (!page) {
      page = this.paginatorData.currentPage;
    }

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    this.timebandService.getList(page, perPage, 'sortBy created desc').then((response) => {
      this.setTimebands(response);
    });
  }

  /**
   * Function to navigates to the timeband create/edit state
   */
  public createTimeband = () => {
    this.$state.go('timeband-manager', { timebandId: '' });
  }

  /**
   * Function to navigates to the timeband create/edit state
   */
  public editTimeband = (timeband: InterACT.Interfaces.Timebands.Timeband) => {
    this.$state.go('timeband-manager', { timebandId: timeband.id });
  }

  /**
   * A method that deletes the suplied timeband
   * @param timeband the timeband to delete
   */
  public deleteTimeband = (timeband: InterACT.Interfaces.Timebands.Timeband) => {
    this.userMessagesService.buildConfirmDialog(
      'DELETE_TIMEBAND',
      'CONFIRM_DIALOG.TIMEBANDS.DELETE_CONFIRM',
      undefined,
      'CONFIRM_DIALOG.TIMEBANDS.CONFIRM',
      'CONFIRM_DIALOG.TIMEBANDS.CANCEL'
    ).then(() => {
      this.timebandService.delete(timeband).then(() => {
        this.userMessagesService.showToast('TIMEBAND_DELETED');
        this.getData(this.paginatorData.currentPage, this.paginatorData.perPageCount);
      });
    });
  }

  /**
   * A method that is called during controller instantiation
   * @param getTimebandsResponse a service response that contains timebands
   */
  private activate(getTimebandsResponse: InterACT.Interfaces.Timebands.TimebandsResponse) {
    this.PrimaryAction.setActions([{
      name: 'CREATE_TIMEBAND',
      action: this.createTimeband
    }]);

    this.toolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('PRODUCT_VALIDITY_TIMEBANDS');
    });

    this.breadcrumbService.setBreadcrumbs([{
      name: 'ABT_CONFIGURATION',
      sref: '#'
    }, {
      name: 'PRODUCT_VALIDITY_TIMEBANDS',
      sref: 'view-timebands'
    }]);

    this.setTimebands(getTimebandsResponse);
  }

  /**
   * A method that sets the timebands on this controller using the supplied timebands response
   * @param timebandsResponse the respons to get the timebands from
   */
  private setTimebands(timebandsResponse: InterACT.Interfaces.Timebands.TimebandsResponse) {
    this.paginatorData.totalCount = timebandsResponse.meta.totalCount;

    this.timebands = timebandsResponse.timebands.map((timebandWithMeta) => {
      return timebandWithMeta.timeband;
    });
  }
}